<template>
    <iframe
        v-if="data?.videoSource"
        v-bind="attributes"
        frameborder="0"
        allowfullscreen
    />
    <img
        v-else-if="data?.imageSource"
        v-bind="attributes"
        :alt="data?.source"
    />
</template>

<script setup>
import { defineProps, onMounted, ref } from "vue"

const props = defineProps({
    data: {
        type: Object,
        required: true,
    }
})

const aspectRatio = props.data?.videoAspectRatio ?? props.data?.imageAspectRatio

const attributes = ref({
    id: props.data?.id,
    src: props.data?.videoSource || props.data?.imageSource,
    style: aspectRatio ? `height: auto; aspect-ratio: ${aspectRatio};` : '',
    width: '100%',
})

onMounted(() => {
    if (props.data?.imageUpdateInterval > 0) {
        setInterval(() => {
            attributes.value.source = `${props.data?.source}?t=${Date.now()}`
        }, parseInt(props.data?.updateInterval) * 1000)
    }
})
</script>
